import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { CollectiblesLayout } from '@/layouts/CollectiblesLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { noPreRenderedStaticPaths } from '@/utils/nextUtils/staticPages'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CollectiblesView } from '@/views/CollectiblesViews'

interface CollectiblesLandingProps {
  locale: string
}

export const CollectiblesLanding: NextPageWithLayout<CollectiblesLandingProps> = ({ locale }) => {
  const { t } = useTranslate('collectibles')

  const title = t('angelCollectibleScenes', 'Angel Collectible Scenes')
  const description = t(
    'ownADigitalFrameAngel',
    'Own a digital frame of your favorite shows and movies from Angel and help support future shows.',
  )

  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          locale,
          path: paths.collectiblesMarketplace.index,
          title,
          description,
          cloudinaryImagePath: 'v1756153598/angel-studios/seo/angel-opengraph-5',
          cloudinaryTransformation: '',
        })}
        noindex
        nofollow
      />
      <div className="bg-core-gray-100 py-8">
        <CollectiblesView />
      </div>
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler<CollectiblesLandingProps>(
  { filePath: 'pages/[locale]/collectibles/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'collectibles'])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

export const getStaticPaths = noPreRenderedStaticPaths

CollectiblesLanding.getLayout = (page) => {
  return <CollectiblesLayout isDarkMode={false}>{page}</CollectiblesLayout>
}

export default CollectiblesLanding
